import styles from './UIGameActionButtonTurnToggleCount.module.scss'
import React from 'react'
import IconPlayers from '@static/images/icon_player.svg'
import {useCurrentStateValidator} from '../../../store/selectors/useCurrentStateValidator.ts'
import {useGameStore} from '../../../store/GameStoreContext.ts'

export const UIGameActionButtonTurnToggleCount = () => {
    const currentStateValidator = useCurrentStateValidator()
    const playerStates = useGameStore((state) => state.gameState.playerStates)

    const numberOfPlayersToggledEndTurn = currentStateValidator.playersToggledEndTurn.length
    const numberOfPlayers = Object.keys(playerStates).length

    return <TurnToggleCount
        numberOfPlayersToggledEndTurn={numberOfPlayersToggledEndTurn}
        numberOfPlayers={numberOfPlayers} />
}

export const TurnToggleCount = ({
    numberOfPlayersToggledEndTurn,
    numberOfPlayers,
}: {
    numberOfPlayersToggledEndTurn: number
    numberOfPlayers: number
}) => (
    <>
        <img src={IconPlayers} className={styles.icon} />
        <span>{numberOfPlayersToggledEndTurn}</span>
        <span>/</span>
        <span>{numberOfPlayers}</span>
    </>
)
